import { TableNew } from '@lune-fe/lune-ui-lib'

import { PaginatedReports } from 'endpoints/dapi'

import ReportsTableRow from './ReportsTableRow'

const ReportsTable = ({
    paginatedReports,
    loading,
}: {
    paginatedReports?: PaginatedReports
    loading: boolean
}) => {
    return (
        <TableNew.TableContainer>
            <TableNew
                sx={{ minWidth: paginatedReports?.data.length ? '800px' : 'auto' }}
                stickyHeader
                loading={!paginatedReports || loading}
                empty={!loading && !paginatedReports?.data.length}
                headerCells={
                    <>
                        <TableNew.TableCell colSize={4}>Description</TableNew.TableCell>
                        <TableNew.TableCell colSize={4}>Date generated</TableNew.TableCell>
                        <TableNew.TableCell colSize={3}>File size</TableNew.TableCell>
                        <TableNew.TableCell colSize={4}>Status</TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd />
                    </>
                }
                bodyCells={
                    <>
                        {paginatedReports?.data.map((item, i: number) => (
                            <ReportsTableRow key={i} item={item} />
                        ))}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default ReportsTable
